//
//
//
//

import RecoveryPasswordForm from '../components/forms/RecoveryPasswordForm';

export default {
	auth: false,
	name: 'Recuperar',
	components: {
		RecoveryPasswordForm,
	},
	head() {
		return {
			title: 'Recuperar contraseña  | La Reverde',
		};
	},
};
